
export default {
  data() {
    return {
        items: [
          {
            label: '不得转让',
            value: '不得转让'
          },
          {
            label: '整体转让',
            value: '整体转让'
          },
          {
            label: '允许分割转让',
            value: '允许分割转让'
          }
        ],
        et1: '允许分割转让',
        et2: '允许分割转让',
        et3: '允许分割转让',
        et4: '不得转让',

        et5: '允许分割转让',
        et6: '允许分割转让',
        et7: '允许分割转让',

        et8: '允许分割转让',
        et9: '允许分割转让',
        et10: '允许分割转让',

        et11: '允许分割转让',
        et12: '允许分割转让',
        et13: '不得转让',
        et14: '允许分割转让',


        et15: '允许分割转让',
        et16: '允许分割转让',
        et17: '允许分割转让',
        et18: '允许分割转让',
        et19: '允许分割转让',
        et20: '允许分割转让',
        et21: '允许分割转让',
        et22: '允许分割转让',
        et23: '允许分割转让',
        et24: '允许分割转让',

        et25: '允许分割转让',
        et26: '允许分割转让',
        et27: '允许分割转让',
        et28: '允许分割转让',
        et29: '允许分割转让',
        et30: '允许分割转让',
        et31: '允许分割转让',
        et32: '允许分割转让',
        et33: '允许分割转让',
        et34: '允许分割转让',

        et35: '允许分割转让',
        et36: '允许分割转让',
        et37: '允许分割转让',
    }
  },
  props: {
   
  },
  methods: {
    changeSelection(e, val) {      
          let target = this.$refs[`et${val}`].$el          
          this.$emit('changeSelection', {target, value: e })        
    },
  },
};
